<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md relative">
      <button class="absolute bg-transparent border-0 outline-none top-2 right-4 text-gray-700 hover:text-black text-2xl admin-button--ghost admin-button--icon" aria-label="Schließen" title="Schließen" @click="$emit('close')">
        <i class="fa fa-xmark"></i>
      </button>
      <h2 class="text-xl font-bold mb-4">Vorlage hochladen</h2>
      <form @submit.prevent="submitTemplate">
        <div class="mb-4">
          <label class="block font-semibold mb-1">Vorlagenname</label>
          <input type="text" v-model="templateName" class="w-full border rounded px-2 py-1 mb-2" :disabled="!file" required />
        </div>
        <div class="mb-4">
          <label class="block font-semibold mb-1">Datei (.docx)</label>
          <div
            class="border-2 border-dashed border-gray-400 rounded px-3 py-6 w-full text-center cursor-pointer mb-2 transition-colors"
            :class="{ 'bg-blue-50 border-blue-400': isDragging }"
            @dragover.prevent="onDragOver"
            @dragleave.prevent="onDragLeave"
            @drop.prevent="onDrop"
            @click="$refs.fileInput.click()"
          >
            <span v-if="!file">Datei hierher ziehen oder klicken, um auszuwählen</span>
            <span v-else>{{ file.name }}</span>
          </div>
          <input type="file" ref="fileInput" accept=".docx" @change="onFileChange" required class="hidden" />

          <div v-if="placeholdersLoading" class="text-blue-600 text-sm mt-2">Platzhalter werden geprüft...</div>
          <div v-if="placeholdersError" class="text-red-600 text-sm mt-2">{{ placeholdersError }}</div>
          <div v-if="!placeholdersLoading && placeholders.length > 0" class="text-sm mt-2">
            <span class="font-semibold">Gefundene Platzhalter:</span>
            <ul class="list-disc list-inside text-left">
              <li v-for="ph in placeholders" :key="ph">{{ ph }}</li>
            </ul>
          </div>
        </div>
        <div class="mb-4">
          <label class="block font-semibold mb-1">Verwendungszweck</label>
          <select v-model="purpose" class="border rounded px-3 py-2 w-full" required>
            <option value="Schulung">Schulung</option>
            <option value="Unterweisung">Unterweisung</option>
          </select>
        </div>
        <div class="flex justify-end gap-2">
          <button type="button" class="bg-gray-300 text-gray-700 rounded px-4 py-2 admin-button--secondary" @click="$emit('close')">Abbrechen</button>
          <button type="submit" class="bg-blue-500 text-white rounded px-4 py-2 admin-button--primary" :disabled="!file || !templateName">Hochladen</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CASP from '@/CASP.js';
export default {
  name: 'TemplateUploadModal',
  data() {
    return {
      file: null,
      templateName: '',
      isDragging: false,
      purpose: 'Schulung',
      placeholders: [],
      placeholdersLoading: false,
      placeholdersError: null,
      base64File: ""
    };
  },
  methods: {
    async onFileChange(e) {
      this.file = e.target.files[0] || null;
      if (this.file) {
        this.templateName = this.file.name.replace(/\.docx$/, '');
        await this.checkPlaceholders();
      } else {
        this.templateName = '';
        this.placeholders = [];
      }
      this.isDragging = false;
    },
    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    async onDrop(e) {
      const droppedFiles = e.dataTransfer.files;
      if (droppedFiles && droppedFiles.length > 0) {
        this.file = droppedFiles[0];
        this.templateName = this.file.name.replace(/\.docx$/, '');
        await this.checkPlaceholders();
      }
      this.isDragging = false;
    },
    async checkPlaceholders() {
      this.placeholders = [];
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        this.base64File = reader.result.split(',')[1];
        CASP.checkTemplatePlaceholders(this.base64File, (status, res) => {
          this.placeholders = res.placeholders;
        });
      };
    },

    submitTemplate() {
      if (!this.file || !this.templateName || !this.purpose) return;
      CASP.uploadTemplate(this.base64File, this.templateName, this.purpose, (status, respons) => {
        if (status==201) {
          this.$emit('uploaded');
          this.$emit('close');
        } else {
          alert('Upload fehlgeschlagen!');
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
